// MB-I18N-2A — help FR (extrait de LanguageContext, valeurs inchangées).
export default {
  "os.poshelp.title": "Aide POS",
  "os.poshelp.intro": "Les essentiels de la caisse : encaissement, fidélité, wallet et dépannage rapide, sans quitter le POS.",
  "os.poshelp.guides_heading": "Guides caisse & dépannage",
  "os.poshelp.contact_heading": "Contact support",
  "os.poshelp.contact_cta": "Écrivez-nous",
  "os.kb.good_to_know": "À savoir",
};
